import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-stop-location",
  "use": "icon-ic-stop-location-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-ic-stop-location\"><rect width=\"30\" height=\"30\" rx=\"6\" fill=\"#4C556C\" /><path d=\"M15 5.833c3.452 0 6.25 2.792 6.25 6.235a6.224 6.224 0 0 1-.894 3.214L15 24.167l-5.355-8.885a6.227 6.227 0 0 1 2.135-8.557A6.26 6.26 0 0 1 15 5.833Zm0 4.584c-1.22 0-2.21 1.026-2.21 2.291 0 1.266.99 2.292 2.21 2.292 1.221 0 2.21-1.026 2.21-2.292 0-1.265-.989-2.291-2.21-2.291Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol